(function(){
  if(window.__mqStore) return; window.__mqStore=true;
  function ctx(){
    var n=document.querySelector('[data-mq-variants]'); if(!n) return null;
    var vs; try{vs=JSON.parse(n.textContent);}catch(e){return null;}
    var base=[]; try{base=JSON.parse(n.getAttribute('data-initial')||'[]');}catch(e){}
    return {vs:vs,base:base,cur:n.getAttribute('data-currency')||'EUR',loc:n.getAttribute('data-locale')||'fr'};
  }
  function money(x,c){try{return new Intl.NumberFormat(x.loc,{style:'currency',currency:x.cur}).format(c/100);}catch(e){return (c/100).toFixed(2)+' '+x.cur;}}
  function selection(x){
    var s=x.base.slice();
    document.querySelectorAll('input[data-mq-opt]').forEach(function(i){ if(i.checked) s[+i.getAttribute('data-mq-opt')-1]=i.value; });
    return s;
  }
  function find(x,s){
    for(var i=0;i<x.vs.length;i++){var v=x.vs[i],ok=true;for(var j=0;j<s.length;j++){if(v.options[j]!==s[j]){ok=false;break;}}if(ok)return v;}
    return null;
  }
  function update(fromUser){
    var x=ctx(); if(!x) return;
    document.querySelectorAll('input[data-mq-opt][data-mq-off]:checked').forEach(function(inp){
      var g=inp.closest('[data-mq-group]'); if(!g) return;
      var alt=g.querySelector('input[data-mq-opt]:not([data-mq-off]):not(:disabled)');
      if(alt){ inp.checked=false; alt.checked=true; }
    });
    var s=selection(x), v=find(x,s);
    document.querySelectorAll('[data-mq-group]').forEach(function(g){
      var p=+g.getAttribute('data-mq-group')-1;
      var out=g.querySelector('[data-mq-selected]'); if(out) out.textContent=s[p]||'';
      g.querySelectorAll('input[data-mq-opt]').forEach(function(inp){
        var t=s.slice(); t[p]=inp.value; var tv=find(x,t);
        var off=inp.hasAttribute('data-mq-off')||!(tv&&tv.available);
        var lb=inp.closest('label'); if(lb) lb.classList.toggle('is-soldout',off);
        inp.disabled=off; inp.setAttribute('aria-disabled',off?'true':'false');
      });
    });
    var btn=document.querySelector('[data-mq-atc]'), lab=document.querySelector('[data-mq-btn-label]'), idIn=document.querySelector('[data-mq-variant-id]');
    var add=(btn&&btn.getAttribute('data-label-add'))||'Ajouter au panier', out2=(btn&&btn.getAttribute('data-label-out'))||'Épuisé';
    if(!v){ if(btn) btn.disabled=true; if(lab) lab.textContent='Indisponible'; return; }
    if(idIn) idIn.value=v.id;
    var pe=document.querySelector('[data-mq-price]'), we=document.querySelector('[data-mq-was]');
    if(pe && pe.getAttribute('data-manual')!=='1') pe.textContent=money(x,v.price);
    if(we){
      if(we.getAttribute('data-manual')==='1'){ we.hidden=(we.getAttribute('data-off')==='1'); }
      else if(we.getAttribute('data-off')!=='1' && v.compare_at_price && v.compare_at_price>v.price){ we.textContent=money(x,v.compare_at_price); we.hidden=false; }
      else { we.hidden=true; }
    }
    if(btn) btn.disabled=!v.available;
    if(lab) lab.textContent=v.available?add:out2;
    if(fromUser && window.history && history.replaceState){ try{ var u=new URL(window.location.href); u.searchParams.set('variant',v.id); history.replaceState({},'',u); }catch(e){} }
    document.dispatchEvent(new CustomEvent('mq:variant',{detail:{variant:v,fromUser:!!fromUser}}));
  }
  document.addEventListener('change',function(e){ var t=e.target; if(t && t.matches && t.matches('input[data-mq-opt]')) update(true); });
  function boot(){ update(false); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load',boot);
})();
(function(){
  var box=document.getElementById('mq-diff-compare'); if(!box) return;
  var r=box.querySelector('.mq-diff__range');
  function set(){ box.style.setProperty('--mq-pos', r.value+'%'); }
  r.addEventListener('input', set); set();
})();
(function(){
  var bar=document.getElementById('mq-sticky-atc'); if(!bar) return;
  var mainBtn=document.querySelector('[data-mq-atc]'); if(!mainBtn) return;
  var priceEl=bar.querySelector('[data-mq-sticky-price]');
  var labelEl=bar.querySelector('[data-mq-sticky-label]');
  var stickyBtn=bar.querySelector('[data-mq-sticky-atc]');

  function sync(v){
    if(!v) return;
    var main=document.querySelector('[data-mq-price]');
    if(priceEl && main) priceEl.textContent=main.textContent;
    var add=mainBtn.getAttribute('data-label-add')||'Ajouter au panier';
    var out=mainBtn.getAttribute('data-label-out')||'Épuisé';
    if(labelEl) labelEl.textContent=v.available?add:out;
    if(stickyBtn) stickyBtn.disabled=!v.available;
  }
  document.addEventListener('mq:variant',function(e){ sync(e.detail.variant); });
  if(stickyBtn) stickyBtn.addEventListener('click',function(){ mainBtn.click(); });

  var io=new IntersectionObserver(function(entries){
    var e=entries[0]; if(!e) return;
    if(!e.isIntersecting && e.boundingClientRect.top<0){ bar.setAttribute('data-stuck','true'); }
    else if(e.isIntersecting){ bar.setAttribute('data-stuck','false'); }
  },{threshold:0});
  io.observe(mainBtn);
})();
